import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { GrowthBookService } from 'src/app/services/growthbook/service';
import { HubspotService } from 'src/app/services/hubspot/hubspot.service';
import { AuthState } from 'src/app/store/auth/auth.state';

/**
 * Component that manages HubSpot chat bubble visibility.
 * This component listens to authorization state and GrowthBook flags
 * to control when the chat bubble should be shown or hidden.
 */
@UntilDestroy()
@Component({
  selector: 'app-hubspot-chat',
  template: '',
  standalone: true,
})
export class HubspotChatComponent implements OnInit, OnDestroy {
  private isInitialized = false;

  constructor(
    private readonly hubspotService: HubspotService,
    private readonly growthBook: GrowthBookService,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    // Wait for both authorization and GrowthBook to be ready before initializing
    combineLatest([
      this.store.select(AuthState.authorized).pipe(distinctUntilChanged()),
      this.growthBook.initialized.pipe(filter(initialized => initialized)),
    ]).pipe(
      untilDestroyed(this),
    ).subscribe(([isAuthorized]) => {
      if (isAuthorized && !this.isInitialized) {
        // User just logged in and GrowthBook is ready - initialize chat
        this.isInitialized = true;
        this.hubspotService.controlChatVisibility();
      } else if (!isAuthorized && this.isInitialized) {
        // User logged out - reset state
        this.isInitialized = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.isInitialized = false;
  }
}
